import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '../../../axios/axiosInstance';

export const useLikeMatchProfile = () =>
  useMutation(async ({ id, action }: { id: number; action: string }) => {
    const { data } = await axiosInstance.post(`api/profile-actions/${id}`, { action });
    return data;
  });
